"use client";

import { usePathname } from "next/navigation";
import { createContext, useContext } from "react";
const PathContext = createContext();
export default function PathProvider({ children }) {
  const pathname = usePathname();
  const getThemeColor = () => {
    if (pathname.includes("/merchant")) return "var(--color-primary-blue)";
    return "var(--color-primary-orange)";
  };
  const color = getThemeColor();
  const value = {
    pathname,
    color,
    isMerchantPage: pathname.includes("/merchant"),
  };
  return <PathContext.Provider value={value}>{children}</PathContext.Provider>;
}
export const usePath = () => useContext(PathContext);
